export const NAVIGATION_TABS_ITEMS = [
  {
    string: `DASHBOARD`,
    url: `MYWM_DASHBOARD`,
    isExternal: false,
  },
  {
    string: `BILLING`,
    url: `MYWM_USER_MYPAYMENT_BILLING`,
    isExternal: false,
  },
  {
    string: `SERVICES`,
    url: `MYWM_USER_MYSERVICES`,
    isExternal: false,
  },
]

export const MULTI_NAVIGATION_TABS_ITEMS = [
  {
    string: `DASHBOARD`,
    url: `MYWM_DASHBOARD`,
    isExternal: false,
  },
  {
    string: `BILLING`,
    url: `MYWM_USER_MYPAYMENT_BILLING`,
    isExternal: false,
  },
]
